/**
 * Remove the first element from the array.
 * @param {Array} array - Array from which the element will be removed.
 * @return {Array} New array with removed first element.
 */
export default function immutableShift(array) {
  return array.slice(1);
}
